// pages/index.js

import { withI18nStaticProps } from "@/lib/withI18nStaticProps";

import KulturKlubIndex from "@/themes/kulturklub/index";
import PrinterwebshopIndex from "@/themes/printerwebshop/index";

const themes = {
  kulturklub: KulturKlubIndex,
  printerwebshop: PrinterwebshopIndex,
};

export default function IndexPage({ products }) {
  const theme = (process.env.NEXT_PUBLIC_THEME || "kulturklub").trim();
  const ThemedIndex = themes[theme] || themes.kulturklub;

  return <ThemedIndex products={products} />;
}

async function baseGetStaticProps() {
  const url =
    process.env.STRAPI_URL +
    "/api/homepage-short-list";

  const res = await fetch(url);
  const json = await res.json();

  return {
    props: {
      products: json.data, // ⬅️ NYERS adat
    },
    revalidate: 60,
  };
}

export const getStaticProps = withI18nStaticProps(baseGetStaticProps, { locale: "hu" });